module.exports = __webpack_public_path__ + "static/home-search-form-front-2-3e780569346394c0c5d2f4dc142e677e.png";